class Carousel {
  constructor(swiperContainer, parameters = {}) {
    this.container = swiperContainer;
    this.parameters = parameters;
    this.instance = null;
  }

  active() {
    this.instance = new Swiper(this.container, this.parameters);
  }

  inactive() {
    if (this.instance !== null) {
      this.instance.destroy();
    }
  }
}

const swiperBaseOptions = {
  containerModifierClass: 'js-swiper-container-',
  wrapperClass: 'js-swiper-wrapper',
  slideClass: 'js-swiper-slide',
  speed: 1000,
  loop: true,
};
const swiperFadeOptions = {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
};

function topKv() {
  const topKvSlides = document.querySelectorAll(
    '.p-topKv .js-swiper-top .js-swiper-slide',
  );
  topKvSlides.forEach((element, index) => {
    const topKvPaginationCurrent = element.querySelector(
      '.swiper-pagination-current',
    );
    const topKvPaginationTotal = element.querySelector(
      '.swiper-pagination-total',
    );

    topKvPaginationCurrent.textContent = index + 1;
    topKvPaginationTotal.textContent = topKvSlides.length;
  });

  // eslint-disable-next-line no-new
  new Swiper('.p-topKv .js-swiper-top', {
    ...swiperBaseOptions,
    ...swiperFadeOptions,
    autoplay: {
      delay: 3000,
    },
    speed: 2000,
    navigation: {
      nextEl: '.p-topKv .js-swiper-button-next',
      prevEl: '.p-topKv .js-swiper-button-prev',
    },
  });
}

function kvLP() {
  // eslint-disable-next-line no-new
  new Swiper('.p-kvLP .js-swiper-lp', {
    ...swiperBaseOptions,
    ...swiperFadeOptions,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 2000,
    pagination: {
      el: '.p-kvLP__pagination',
      clickable: true,
    },
  });
}

function blockGalleryTemplate() {
  const blockGalleryElements = document.querySelectorAll('.block-gallery');

  blockGalleryElements.forEach(element => {
    const galleryThumbs = new Swiper(
      element.querySelector('.js-swiper-thumbnails'),
      {
        ...swiperBaseOptions,
        loop: false,
        slidesPerView: 'auto',
      },
    );

    // eslint-disable-next-line no-new
    new Swiper(element.querySelector('.js-swiper-gallery'), {
      ...swiperBaseOptions,
      autoHeight: true,
      navigation: {
        nextEl: element.querySelector('.js-swiper-button-next'),
        prevEl: element.querySelector('.js-swiper-button-prev'),
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });
  });
}

function blockGallery() {
  const blockGalleryElements = document.querySelectorAll('.wp-block-gallery');

  blockGalleryElements.forEach(element => {
    const $element = $(element);

    // block-gallery
    $element
      .addClass('block-gallery')
      .removeClass('wp-block-gallery columns-3 is-cropped');

    // block-gallery__container
    $element.wrapInner('<div class="block-gallery__container"></div>');

    // js-swiper-container js-swiper-gallery
    // js-swiper-wrapper
    $element
      .find('.block-gallery__container')
      .wrapInner(
        '<div class="js-swiper-container js-swiper-gallery "><div class="js-swiper-wrapper _notSave"></div></div>',
      );

    const $images = $element
      .find('.js-swiper-gallery .blocks-gallery-item figure')
      .addClass('js-swiper-slide')
      .clone(true);
    $element.find('.js-swiper-gallery .js-swiper-wrapper').prepend($images);
    $element.find('.blocks-gallery-grid').remove();
    $element.find('.blocks-gallery-caption').remove();
    // js-swiper-button-prev
    $element
      .find('.block-gallery__container')
      .append('<div class="block-gallery__prev js-swiper-button-prev"></div>')
      .append('<div class="block-gallery__next js-swiper-button-next"></div>');
    // js-swiper-container js-swiper-thumbnails
    $element.append(
      '<div class="js-swiper-container js-swiper-thumbnails"><div class="block-gallery__thumbnails js-swiper-wrapper _notSave"></div></div>',
    );

    const $thumbnails = $element
      .find('.js-swiper-gallery .js-swiper-slide')
      .clone(true);

    $element.find('.block-gallery__thumbnails').append($thumbnails);
    $element
      .find('.block-gallery__thumbnails .js-swiper-slide')
      .addClass('block-gallery__thumbnail');
    $element
      .find('.block-gallery__thumbnails .block-gallery__thumbnail figcaption')
      .remove();

    const galleryThumbs = new Swiper(
      element.querySelector('.js-swiper-thumbnails'),
      {
        ...swiperBaseOptions,
        autoHeight: true,
        loop: false,
        slidesPerView: 'auto',
      },
    );

    // eslint-disable-next-line no-new
    new Swiper(element.querySelector('.js-swiper-gallery'), {
      ...swiperBaseOptions,
      autoHeight: true,
      navigation: {
        nextEl: element.querySelector('.js-swiper-button-next'),
        prevEl: element.querySelector('.js-swiper-button-prev'),
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });
  });
}

function recommends() {
  const recommendsElements = document.querySelectorAll('.l-recommends');
  const recommendsMediaQuery = window.matchMedia(
    'screen and (max-width: 980px)',
  );
  const recommendCarouselMobileInstance = [];
  const recommendCarouselDesktopInstance = [];
  const recommendCarousel = () => {
    if (recommendsMediaQuery.matches) {
      recommendCarouselDesktopInstance.forEach(swiper => {
        swiper.inactive();
      });
      recommendCarouselMobileInstance.forEach(swiper => {
        swiper.active();
      });
    } else {
      recommendCarouselMobileInstance.forEach(swiper => {
        swiper.inactive();
      });
      recommendCarouselDesktopInstance.forEach(swiper => {
        swiper.active();
      });
    }
  };

  recommendsElements.forEach(element => {
    const mobileSlide = element.querySelectorAll('.js-swiper-slide');
    recommendCarouselMobileInstance.push(
      new Carousel(element.querySelector('.js-swiper-recommend'), {
        ...swiperBaseOptions,
        autoplay: {
          delay: 3000,
        },
        loop: mobileSlide.length > 1,
        watchOverflow: true,
        pagination: {
          el: element.querySelector('.js-swiper-pagination'),
          bulletClass: 'l-mustSee__navItem',
          bulletActiveClass: '_current',
          clickable: true,
        },
        navigation: {
          nextEl: element.querySelector('.js-swiper-button-next'),
          prevEl: element.querySelector('.js-swiper-button-prev'),
        },
      }),
    );
    const desktopSlide = element.querySelectorAll('.js-swiper-slide');
    recommendCarouselDesktopInstance.push(
      new Carousel(element.querySelector('.js-swiper-recommend'), {
        ...swiperBaseOptions,
        autoplay: {
          delay: 3000,
        },
        loop: desktopSlide.length > 3,
        watchOverflow: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        loopFillGroupWithBlank: true,
        pagination: {
          el: element.querySelector('.js-swiper-pagination'),
          bulletClass: 'l-mustSee__navItem',
          bulletActiveClass: '_current',
          clickable: true,
        },
        navigation: {
          nextEl: element.querySelector('.js-swiper-button-next'),
          prevEl: element.querySelector('.js-swiper-button-prev'),
        },
      }),
    );
  });

  recommendsMediaQuery.addListener(recommendCarousel);
  recommendCarousel();
}

function mustSee() {
  const mustSeeElements = document.querySelectorAll('.l-mustSee');

  mustSeeElements.forEach(element => {
    // eslint-disable-next-line no-new
    new Swiper(element.querySelector('.js-swiper-container'), {
      ...swiperBaseOptions,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: element.querySelector('.js-swiper-pagination'),
        bulletClass: 'l-mustSee__navItem',
        bulletActiveClass: '_current',
        clickable: true,
      },
      navigation: {
        nextEl: element.querySelector('.js-swiper-button-next'),
        prevEl: element.querySelector('.js-swiper-button-prev'),
      },
    });
  });
}

function stayAround() {
  const stayAroundElements = document.querySelectorAll('.l-stayAround');

  stayAroundElements.forEach(element => {
    const stayAroundImg = new Swiper(
      element.querySelector('.l-stayAround__carouselImg'),
      {
        ...swiperBaseOptions,
        ...swiperFadeOptions,
      },
    );
    const stayAroundBody = new Swiper(
      element.querySelector('.l-stayAround__body'),
      {
        ...swiperBaseOptions,
        ...swiperFadeOptions,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: element.querySelector('.js-swiper-pagination'),
          bulletClass: 'l-stayAround__navItem',
          bulletActiveClass: '_current',
          clickable: true,
          renderBullet(index, className) {
            return `<li class="${className}"></li>`;
          },
        },
        navigation: {
          nextEl: element.querySelector('.js-swiper-button-next'),
          prevEl: element.querySelector('.js-swiper-button-prev'),
        },
      },
    );

    stayAroundImg.controller.control = stayAroundBody;
    stayAroundBody.controller.control = stayAroundImg;
  });
}

function delayAutoPlay() {
  const $opening = $('.p-opening');
  const $swiperAutoPlayContainer = $('.js-swiper-container').filter(
    (index, element) =>
      typeof element.swiper !== 'undefined' && element.swiper.autoplay.running,
  );

  if ($opening.length === 0) return;

  $swiperAutoPlayContainer.each((index, element) => {
    element.swiper.autoplay.stop();
  });
  $opening.one('openingComplete', () => {
    $swiperAutoPlayContainer.each((index, element) => {
      element.swiper.autoplay.start();
    });
  });
}

export default function slider() {
  topKv();
  kvLP();
  blockGallery();
  blockGalleryTemplate();
  recommends();
  mustSee();
  stayAround();
  delayAutoPlay();
}
